import { useCallback, useState } from 'react';
import type {
    SmriqGeneratedService,
    SmriqPricingVariantRecord,
    SmriqWorkItem,
} from '../types/smriq.types';

type Reconcile = (services: { id: string; declined_items: SmriqWorkItem[] }[]) => void;

/** The raw generate response behind the current schedule: its visits and the price set applied. */
export function useSmriqGeneratedPlan(reconcile: Reconcile) {
    const [generatedServices, setGeneratedServices] = useState<SmriqGeneratedService[]>([]);
    const [pricingVariant, setPricingVariant] = useState<SmriqPricingVariantRecord | null>(null);

    // The server's declined_items[] always wins over whatever was toggled locally.
    const handleGenerated = useCallback(
        (services: SmriqGeneratedService[], variant: SmriqPricingVariantRecord | null = null) => {
            setGeneratedServices(services);
            setPricingVariant(variant);
            reconcile(services);
        },
        [reconcile],
    );

    return { generatedServices, pricingVariant, handleGenerated };
}
